class DlTopBarM extends HTMLElement {
    constructor() {
        super();
        this.storageKey = 'dl-top-bar-m-closed';
        this.container = this.closest('.dl-top-bar-m');
        this.annoucementBar = document.querySelector('.dl-section-announcement-bar-h');
        this.expireDays = this.dataset.expireDays;
        this.excludePages = this.dataset.excludePages;
        if (!this.expireDays) {
            this.expireDays = 1;
        }
    }
    
    connectedCallback() {
        const isClosed = this.isClosedRecently();
        const isExcluded = this.isExcluded();
        if (isClosed || isExcluded) {
            return;
        }
        this.annoucementBar?.classList.add('dl-section-announcement-bar-h--hidden');
        this.container.classList.add('dl-top-bar-m-show');
        this.closeButton = this.querySelector('.dl-top-bar-m-close-button');
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.handleClose.bind(this));
        }
        this.addEventListener('click', this.handleClick.bind(this));
        DLPixelH.capture('top_notification_bar_show');
    }
    
    isExcluded() {
        if (!this.excludePages) {
            return false;
        }
        const excludePages = this.excludePages.split('\n');
        return excludePages.some(page => window.location.pathname.includes(page));
    }

    isClosedRecently() {
        try {
            const closedTime = localStorage.getItem(this.storageKey);
            if (!closedTime) return false;
            
            const now = Date.now();
            const timeDiff = now - parseInt(closedTime);
            const oneDayInMs = this.expireDays * 60 * 60 * 1000; // 24小时
            
            return timeDiff < oneDayInMs;
        } catch (e) {
            return false;
        }
    }
    
    handleClick(event) {
        if (event.target.classList.contains('dl-top-bar-m-close-button')) {
            return;
        }
        DLPixelH.capture('top_notification_bar_click');
    }
    
    handleClose() {
        try {
            DLPixelH.capture('top_notification_bar_close_btn_click');
            // 保存关闭时间戳
            localStorage.setItem(this.storageKey, Date.now().toString());
            this.annoucementBar?.classList.remove('dl-section-announcement-bar-h--hidden');
        } catch (e) {
            console.error('Failed to save close state:', e);
        }
        this.remove();
    }
}

customElements.define('dl-top-bar-m', DlTopBarM);